function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(2 2)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2.178,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4.882 5.113h6.235L18.099 0h9.31l7.253 7.04v6.466l-3.346 1.92v9.56L19.772 35.838H12.5l-3.902 3.709-6.269-3.709L0 32.114v-9.17l4.882-4.89z"
}), React.createElement("path", {
  d: "M24.694 1.879l-7.046 9.237 4.924 4.25 9.169-2.032",
  stroke: "#FFF",
  strokeWidth: 1.5,
  strokeLinejoin: "round",
  strokeDasharray: "3 1.470000028610229"
}), React.createElement("ellipse", {
  fill: "#FFF",
  cx: 28.152,
  cy: 8.75,
  rx: 2.283,
  ry: 2.25
}));

var SvgIrishBorder = function SvgIrishBorder(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 43"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzhweCIgaGVpZ2h0PSI0M3B4IiB2aWV3Qm94PSIwIDAgMzggNDMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iRGVza3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5My4wMDAwMDAsIC02MjQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC02IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0OTUuMDAwMDAwLCA2MjYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUmVjdGFuZ2xlLTgiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyLjE3OCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBwb2ludHM9IjQuODgxNjU1MDEgNS4xMTI3MzU1MyAxMS4xMTY4NjUzIDUuMTEyNzM1NTMgMTguMDk4NjcxNCAwIDI3LjQwODE5IDAgMzQuNjYyMDYwMyA3LjAzOTA4NjA1IDM0LjY2MjA2MDMgMTMuNTA2MzEzMyAzMS4zMTU2ODc4IDE1LjQyNTQ1NTMgMzEuMzE1Njg3OCAyNC45ODYzNDQ4IDE5Ljc3MTg1NzcgMzUuODM4MjY5MiAxMi41MDEwMDQxIDM1LjgzODI2OTIgOC41OTg5NDA4NyAzOS41NDY2NDYxIDIuMzMwMDk2OTUgMzUuODM4MjY5MiAxLjc2MTc4MjMzZS0xNCAzMi4xMTM4MjEyIDAgMjIuOTQzOTkyMSA0Ljg4MTY1NTAxIDE4LjA1NDM5ODYiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNC42OTQwODEyLDEuODc4OTA2MjUgTDE3LjY0NzYxNjYsMTEuMTE2MjEwOSBMMjIuNTcyNDYzOCwxNS4zNjYyMTA5IEwzMS43NDA1NDU3LDEzLjMzMzk4NDQiIGlkPSJMaW5lLTQiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1kYXNoYXJyYXk9IjMsMS40NzAwMDAwMjg2MTAyMjkiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsLTQiIGZpbGw9IiNGRkZGRkYiIGN4PSIyOC4xNTIxNzM5IiBjeT0iOC43NSIgcng9IjIuMjgyNjA4NyIgcnk9IjIuMjUiPjwvZWxsaXBzZT4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIrishBorder as ReactComponent };